module.exports = __webpack_public_path__ + "static/img/logo_abft_impression.a8b66ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_abft_impression.png
// module id = rud2
// module chunks = 1